import { jsx, jsxs } from 'react/jsx-runtime';
import { useIsClientReady, useWindowSize, BREAKPOINTS_WIDTHS } from '@belong/common';
import clsx from 'clsx';
import { camelCase } from 'es-toolkit/compat';
import { Avatar } from '../Avatar/Avatar.js';
import { Loader } from '../Loader/Loader.js';
import { Text } from '../Text/Text.js';
import css from './Bubble.module.css.js';

const VARIANT_TO_BG_COLOR_MAP = {
  primary: 'bg-light-gray',
  secondary: 'bg-white',
  tertiary: 'bg-darker-navy'
};
const VARIANT_TO_BORDER_COLOR_MAP = {
  primary: 'border border-solid border-gray',
  secondary: 'border border-solid border-gray',
  tertiary: 'border-none'
};
function Bubble({
  arrowPosition = 'top',
  borderRadius = 'default',
  variant = 'primary',
  fluid = false,
  className,
  ...rest
}) {
  return jsx("div", {
    className: clsx(css.bubble, 'relative p-sm', VARIANT_TO_BG_COLOR_MAP[variant], VARIANT_TO_BORDER_COLOR_MAP[variant], {
      [css.defaultRadius]: borderRadius === 'default',
      rounded: borderRadius === 'small'
    }, [css[camelCase(arrowPosition)]], fluid && 'w-full', className),
    children: 'text' in rest ? jsx(Text, {
      fontWeight: "semibold",
      variant: "h3",
      as: "h3",
      className: "text-navy",
      children: rest.text
    }) : rest.children
  });
}
Bubble.Employee = ({
  text,
  avatarSrc = '',
  name,
  role = 'Homeowner Advisor',
  isLoading = false,
  showAnimation = false,
  fluid = false
}) => {
  const isClientReady = useIsClientReady();
  const {
    width
  } = useWindowSize();
  const isMobile = width <= BREAKPOINTS_WIDTHS.MD;
  if (showAnimation && (isLoading || !name || !avatarSrc)) {
    return jsx(Loader.BubbleEmployee, {});
  }
  return jsxs("div", {
    className: "contents",
    children: [jsxs("div", {
      className: "flex items-center",
      children: [jsx("div", {
        className: "mr-sm hidden self-end md:block",
        children: jsx(Avatar, {
          size: 70,
          src: avatarSrc
        })
      }), isClientReady && jsx(Bubble, {
        arrowPosition: isMobile ? 'bottom-left' : 'left-bottom',
        fluid: fluid,
        children: jsx(Text, {
          fontWeight: "semibold",
          variant: "h3",
          className: "text-navy",
          children: text
        })
      })]
    }), jsxs("div", {
      className: "flex md:flex-col",
      children: [jsx("div", {
        className: "mr-sm mt-sm flex md:hidden",
        children: jsx(Avatar, {
          size: 70,
          src: avatarSrc
        })
      }), jsxs("div", {
        className: "mt-sm flex flex-col justify-center md:flex-row md:justify-start",
        children: [jsx(Text, {
          fontWeight: "semibold",
          className: "mr-2xs text-navy",
          as: "span",
          children: name
        }), jsx(Text, {
          className: "text-navy",
          as: "span",
          children: role
        })]
      })]
    })]
  });
};

export { Bubble };
